<mat-form-field style="width: 100%">
  <mat-label>{{ label }}</mat-label>
  <textarea
    [(ngModel)]="value"
    matInput
    [attr.rows]="rows"
    [minlength]="minlength || 0"
    [placeholder]="placeholder || ''"
    [cdkTextareaAutosize]="autosize"
    [cdkAutosizeMinRows]="autosizeMinRows"
    [cdkAutosizeMaxRows]="autosizeMaxRows"
  ></textarea>
</mat-form-field>
